import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICompany } from '../../interfaces/companies/company.model';
import { CompanyFormV2Component } from '../../shared/forms/companies/company-form/company-form-v2.component';
import { CompanyModel } from '../../shared/models/company.model';
import { CompanyService } from '../../shared/services/company/company.service';
import { IntercomService } from '../../shared/services/intercom/intercom.service';
import { MessageService } from '../../shared/services/message/message.service';
import { GatekeeperModalComponent } from '../modal.component';

@Component({
  selector: 'gk-add-company-modal',
  templateUrl: './add-company-modal.component.html',
  styleUrls: ['./add-company-modal.scss']
})
export class AddCompanyModalComponent extends GatekeeperModalComponent<AddCompanyModalComponent> {
  company = new CompanyModel(<ICompany>{});

  @ViewChild(CompanyFormV2Component, { static: true })
  addCompanyForm = <CompanyFormV2Component>{};

  constructor(
    private messageService: MessageService,
    private intercomService: IntercomService,
    private companyService: CompanyService,
    public dialogRef: MatDialogRef<AddCompanyModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.company = new CompanyModel(<ICompany>{});
  }

  saveCompany() {
    if (!this.addCompanyForm.theForm.valid) {
      this.showErrors();
      return;
    }
    const companyToSave = <ICompany>{};
    Object.assign(companyToSave, this.company);

    if (
      !companyToSave.address.line1 &&
      !companyToSave.address.town &&
      !companyToSave.address.postcode
    ) {
      companyToSave.address = null;
    }

    return this.companyService
      .addCompany(companyToSave)
      .then(r => (this.company = r))
      .then(() => {
        this.messageService.showIcon(MessageTypeEnum.Success);
        this.intercomService.markToFetchDetails();
        this.close(companyToSave);
      })
      .catch(() => {
        this.messageService.showMessage(
          MessageTypeEnum.Danger,
          'COMPANY_NOT_SAVED',
          { name: this.company.name }
        );
      });
  }

  showErrors() {
    Object.keys(this.addCompanyForm.theForm.controls).forEach(key => {
      this.addCompanyForm.theForm.get(key).markAsDirty();
    });
  }
}
